import styled from "@emotion/styled";
import { Button, ButtonProps, buttonClasses } from "@kaltura/ds-react-components";

const StyledButtonWrapper = styled("div")(({ theme }) => ({
    position: "relative",
    overflow: "hidden",
    padding: theme.spacing(0.5),
}));

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(3),
    position: "absolute",
    right: -1000,
    top: -1000,
    [`&.${buttonClasses.focusVisible}`]: {
        position: "static",
    },
}));

/**
 * a form save button, visible on screen only when tabbed to.
 *
 * used to provide keyboard users a convenient way
 * to save the form, in addition to the save button at the top
 * of the form.
 */
export const BottomSaveButton = (props: ButtonProps) => {
    return (
        <StyledButtonWrapper>
            <StyledButton {...props} />
        </StyledButtonWrapper>
    );
};
